import React from 'react';

interface MessageFloatingButtonProps {
  onClick: () => void;
  unreadCount?: number;
}

export const MessageFloatingButton: React.FC<MessageFloatingButtonProps> = ({ 
  onClick, 
  unreadCount = 0 
}) => {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-4 right-4 z-40 w-14 h-14 bg-emerald-600 hover:bg-emerald-700 rounded-full shadow-lg transition-all duration-300 hover:scale-110 flex items-center justify-center group"
    >
      <svg 
        className="h-6 w-6 text-white" 
        fill="none" 
        viewBox="0 0 24 24" 
        stroke="currentColor"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" 
        />
      </svg>
      
      {/* Badge de notifications */}
      {unreadCount > 0 && (
        <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-6 h-6 flex items-center justify-center font-bold">
          {unreadCount > 99 ? '99+' : unreadCount}
        </div>
      )}
      
      {/* Effet de brillance */}
      <div className="absolute inset-0 rounded-full bg-gradient-to-r from-emerald-400 to-cyan-400 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
    </button>
  );
};
